import { Box, Typography } from '@mui/material';
import SvgWarning from '../../../../components/icons/Warning';
import SvgSuitcase from '../../../../components/icons/Suitcase';

const STATUS_CONFIG = {
  info: {
    borderColor: '#995A00',
    bgColor: 'rgba(153, 90, 0, 0.12)',
    Icon: SvgWarning,
  },
  danger: {
    borderColor: '#CC0000',
    bgColor: 'rgba(204, 0, 0, 0.08)',
    Icon: SvgSuitcase,
  },
  success: {
    borderColor: '#008000',
    bgColor: 'rgba(0, 128, 0, 0.08)',
    Icon: SvgSuitcase,
  },
};

const BenefitStatusInfoCard = ({ data }) => {
  if (!data) return null;

  const config = STATUS_CONFIG[data?.status] ?? STATUS_CONFIG.info;
  const { Icon } = config;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 2,
        border: `1px solid ${config.borderColor}`,
        borderRadius: '16px',
        background: config.bgColor,
      }}
    >
      <Icon
        fill={config.borderColor}
        style={{ width: '24px', height: '24px', flexShrink: 0 }}
      />
      <Typography
        variant='h3'
        sx={data?.status == 'danger' ? { color: '#CC0000' } : { color: '#333' }}
      >
        {data?.display_message}
      </Typography>
    </Box>
  );
};

export default BenefitStatusInfoCard;
